export default __webpack_public_path__ + "static/partnerIcon12-cd555b76871eaa3dedfccb3580239cb9.svg";